<script setup>
import { WButton, WParagraph } from '@alice-health/wonderland-vue'
import { onMounted, onUnmounted, ref } from 'vue'

const props = defineProps({
  dataText: {
    type: Array,
    default: () => []
  },
  showButton: {
    type: Boolean,
    default: false
  }
})

const position = ref(0)
const timeout = ref(null)

const emit = defineEmits(['onStop'])

const flipText = () => {
  position.value =
    position.value < props.dataText.length - 1 ? position.value + 1 : 0

  timeout.value = setTimeout(flipText, 4000)
}

onMounted(() => {
  flipText()
})
onUnmounted(() => {
  clearTimeout(timeout.value)
})
</script>

<template>
  <div class="loader__header">
    <WParagraph
      v-for="(text, index) in props.dataText"
      v-show="position === index"
      :key="index"
      :class="{ fade: position === index }"
    >
      {{ text }}
    </WParagraph>
    <WButton v-if="showButton" variant="tertiary" @click="emit('onStop')">
      Interromper
    </WButton>
  </div>
  <div class="loader__loading"></div>
</template>

<style lang="scss" scoped>
.loader {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__loading {
    margin-top: var(--gl-spacing-04);
    background-color: var(--gl-color-shades-gray-20);
    border-radius: var(--gl-border-radius-sm);
    position: relative;
    height: 4px;

    &::after {
      position: absolute;
      left: 0;
      width: 30%;
      content: '';
      height: 4px;
      border-radius: var(--gl-border-radius-sm);
      animation: load 1s alternate infinite;
      background: linear-gradient(
        to left,
        var(--gl-color-shades-violet-30),
        var(--gl-color-shades-magenta-60)
      );
    }
  }
}
.fade {
  animation-name: fade;
  animation-duration: 2s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes load {
  0% {
    left: 0;
  }
  100% {
    left: 70%;
  }
}
</style>
